import { SalesSites } from './sales-sites.component';

export * from './sales-sites.component';
export default SalesSites;

if (!customElements.get('der-tm-appointment-booking-sales-sites')) {
    customElements.define('der-tm-appointment-booking-sales-sites', SalesSites);
}
